import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import Avatar from './Avatar'
import {
  WebcamImage
} from '../device/'
import { getDeviceLabel, fmtzDate, removeFromArr, getDeviceSharePath } from '../../common/ambient'
import bindAllActions from '../../common/bindAllActions'
import PropTypes from 'prop-types'
import { append, contains, filter, propEq, path } from 'ramda'
import ApiKeys from './ApiKeys'
import { deviceCamTierObj, deviceSubscriptionStatus, AdminUserSubscriptions } from '../payment'
import { rawFeathersRequest } from '../../common/feathers'

const ROLES = ['user',
  'admin',
  'social',
  'dev',
  'wxw-user',
  'awn-plus',
  'awn-plus-teams'
]

class UserCard extends PureComponent {
  static propTypes = {
    u: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    device: PropTypes.object.isRequired,
    userActions: PropTypes.object.isRequired,
    deviceActions: PropTypes.object.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      roles: props.u.roles,
      showRoles: false,
      showMobileDevices: false,
      showDevices: true,
      showApiKeys: false,
      showSubscriptions: false
    }
  }

  _webcam (currentDevice) {
    if (!currentDevice.webcam) return null
    const { userActions, deviceActions, u } = this.props
    const camTierObj = deviceCamTierObj({ info: u }, currentDevice.macAddress)
    console.log('camTierObj', camTierObj)
    let freeEnhancedCam = null
    if (camTierObj.tier < 1) {
      const freeTierOnClick = tier => {
        return () => {
          if (window.confirm(`Grant Free tier ${tier}?`)) {
            const payments = u.payments || {}
            payments.subscriptions = payments.subscriptions || []
            payments.subscriptions.push({
              productName: `awn-camera-tier${tier}-monthly`,
              macAddress: currentDevice.macAddress,
              status: 'free',
              stationId: currentDevice._id,
              created: Math.floor(Date.now() / 1000)
            })
            userActions.patch(u._id, { payments })
          }
        }
      }
      freeEnhancedCam = (
        <div>
          <button className='btn btn-primary' onClick={freeTierOnClick(1)}>Grant Free Tier 1</button>
          <button className='btn btn-primary' onClick={freeTierOnClick(2)}>Grant Free Tier 2</button>
        </div>
      )
    }
    let removeFreeBtn = null
    if (deviceSubscriptionStatus({ info: u }, currentDevice.macAddress, camTierObj.productName) === 'free') {
      removeFreeBtn = (
        <>
          ⭐️ FREE! ⭐️
          &nbsp;
          <button
            className='btn'
            onClick={() => {
              if (window.confirm('Remove Free Tier?')) {
                const payments = u.payments || {}
                payments.subscriptions = payments.subscriptions || []
                payments.subscriptions = filter(sub => sub.macAddress !== currentDevice.macAddress && /camera/.test(sub.productName), payments.subscriptions)
                userActions.patch(u._id, { payments })
              }
          }}>Remove Free Tier</button>
        </>
      )
    }
    return (
      <div>
        <WebcamImage currentDevice={currentDevice} />
        <div>{currentDevice.webcam.public ? 'public' : 'private'}</div>
        <label>
          <input
            type='checkbox'
            checked={currentDevice.webcam.approved}
            onChange={evt => {
              deviceActions.patch(currentDevice._id, {
                webcam: Object.assign({}, currentDevice.webcam, { approved: evt.target.checked })
              })
              deviceActions.patch(currentDevice._id, {
                rank: evt.target.checked ? 2.1 : 0
              })
            }}
          />
          Approved
        </label>
        <label>
          Cam Tier: {camTierObj.label} {removeFreeBtn}
        </label>
        {freeEnhancedCam}
      </div>
    )
  }

  _toggleSection = (section) => {
    this.setState(prevState => ({
      [section]: !prevState[section]
    }))
  }

  _appDevices () {
    const { u } = this.props
    const { showMobileDevices } = this.state
    if (!u.appDevices) return null
    
    const deviceCount = Object.keys(u.appDevices).length
    if (deviceCount === 0) return null
    
    return (
      <div className='app-devices'>
        <div className='section-header' onClick={() => this._toggleSection('showMobileDevices')}>
          <h3>Mobile Devices ({deviceCount})</h3>
          <span className='toggle-icon'>{showMobileDevices ? '▼' : '►'}</span>
        </div>
        {showMobileDevices && (
          <div className='section-content'>
            {Object.keys(u.appDevices).map(appId => {
              const d = u.appDevices[appId]
              return (
                <div className='app-device' key={appId}>
                  <div className='device-info'>
                    <span className='manufacturer-model'>{d.manufacturer} {d.model} {d.version}</span>
                    <span className='device-enabled'>{d.notificationsEnabled ? '✓' : '✗'}</span>
                    <div className='device-details'>
                      <span>ID: {d.fcmToken && d.fcmToken.split(':')[0]}</span>
                      <span>Updated: {fmtzDate('MMM Do YYYY, h:mm:ss a')(d.lastUpdated)}</span>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>
    )
  }

  _renderDevices(devices) {
    const { deviceActions, u } = this.props
    const { showDevices } = this.state
    const { patch } = deviceActions

    if (!devices || devices.length === 0) return null
    
    return (
      <div className='devices-container'>
        <div className='section-header' onClick={() => this._toggleSection('showDevices')}>
          <h3 className='devices-summary'>
            Devices: <span className='devices-count'>{devices.length}</span>
          </h3>
          <span className='toggle-icon'>{showDevices ? '▼' : '►'}</span>
        </div>
        {showDevices && (
          <div className='section-content'>
            {devices.map(d => (
              <div className='device-item' key={d._id}>
                <div className='device-info'>
                  <span className='device-name'>{getDeviceLabel(d)}</span>
                  <span className='device-mac'>{d.macAddress}</span>
                  {d.public && 
                    <Link className='dashboard-link' to={getDeviceSharePath(d)}>
                      dashboard
                    </Link>
                  }
                </div>
                {this._webcam(d)}
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }
  
  _renderSubscriptions(devices) {
    const { u, userActions } = this.props
    const { showSubscriptions } = this.state

    const userSubs = path(['payments', 'subscriptions'], u) || []

    return (
      <div className='subscriptions-container'>
        <div className='section-header' onClick={() => this._toggleSection('showSubscriptions')}>
          <h3 className='subscriptions-summary'>
            Subscriptions: <span className='subscriptions-count'>{userSubs.length}</span>
          </h3>
          <span className='toggle-icon'>{showSubscriptions ? '▼' : '►'}</span>
        </div>
        {showSubscriptions && (
          <div className='section-content'>
            <AdminUserSubscriptions
              user={u}
              devices={devices}
              onRefreshUser={this._refreshViewedUser}
            />
          </div>
        )}
      </div>
    )
  }

  _renderApiKeys() {
    const { u } = this.props
    const { showApiKeys } = this.state
    
    return (
      <div className='apikeys-container'>
        <div className='section-header' onClick={() => this._toggleSection('showApiKeys')}>
          <h3 className='apikeys-summary'>
            API Keys
          </h3>
          <span className='toggle-icon'>{showApiKeys ? '▼' : '►'}</span>
        </div>
        {showApiKeys && (
          <div className='section-content'>
            <ApiKeys u={u} />
          </div>
        )}
      </div>
    )
  }

  _refreshViewedUser = async () => {
    const { u, userActions } = this.props
    try {
      // Fetch the specific user by ID to refresh their data
      await userActions.fetchUsers({
        _id: u._id,
        $limit: 1
      })
    } catch (error) {
      console.error('Error refreshing user:', error)
    }
  }

  render () {
    const { device, u, userActions, deviceActions, user } = this.props
    const { setDashboardDevice, setDeviceI, fetchDevices, patch } = deviceActions
    const { becomeUser } = userActions
    const { roles } = this.state
    const fmt = fmtzDate('MMM Do YYYY')

    // Filter user's devices once for use in multiple render methods
    const { allDevices } = device
    const userDevices = allDevices && filter(propEq('userId', u._id), allDevices)

    let become = ''
    if (user.info._id !== u._id) {
      become = (
        <div className='column'>
          <a
            className='btn btn-primary'
            onClick={async () => {
              const res = await rawFeathersRequest('/users/aaadmin/become', {
                method: 'POST',
                body: JSON.stringify({ _id: u._id })
              })
              const { token } = res
              if (token) {
                window.localStorage.setItem('feathers-jwt', token)
                window.location.replace('/dashboard')
              } else {
                window.alert('error becoming user')
              }
            }}
          >Acutally Become</a>
          <a
            onClick={() => {
              if (user.adminImpersonation && user.adminImpersonation._id === u._id) {
                window.location.reload()
              } else {
                setDeviceI(0)
                setDashboardDevice(false)
                becomeUser(u)
                fetchDevices()
              }
            }}
          >Legacy (kinda) Become</a>
        </div>
      )
    }
    
    return (
      <div className='user-user-card'>
        <div className='top'>
          <Avatar u={u} />
          <div className='name'>
            {u.email}
            {(u.bounced || u.complained) && (
              <div className='warning-box' style={{ marginTop: '10px' }}>
                <strong>Email Delivery Issue:</strong> This user's email has been marked as {u.bounced ? 'bounced' : 'complained'}.
                They won't receive email notifications.
                {' '}
                <a
                  href='#'
                  onClick={(e) => {
                    e.preventDefault()
                    if (window.confirm('Clear email delivery status for this user?')) {
                      userActions.patch(u._id, {
                        bounced: false,
                        complained: false
                      })
                    }
                  }}
                >
                  Click here to clear this status
                </a> and allow them to resume receiving emails.
              </div>
            )}
            <div className='details'>
              Created: {fmt(u.createdAt)}
            </div>
          </div>
          {become}
        </div>
        <div className='bottom'>
          {this._renderDevices(userDevices)}
          {this._renderSubscriptions(userDevices)}
          <div className='roles-container'>
            <div className='section-header' onClick={() => this._toggleSection('showRoles')}>
              <h3 className='roles-summary'>
                Roles: <span className='roles-count'>{roles ? roles.length : 0}</span>
                {roles && roles.length > 0 && <span className='roles-list-mini'> ({roles.join(', ')})</span>}
              </h3>
              <span className='toggle-icon'>{this.state.showRoles ? '▼' : '►'}</span>
            </div>
            {this.state.showRoles && (
              <div className='section-content'>
                {ROLES.map(key =>
                  <label className='role' key={key}>
                    {key}
                    <input
                      type='checkbox'
                      checked={contains(key, roles)}
                      onChange={evt => {
                        const newRoles = contains(key, roles) ? removeFromArr(key, roles) : append(key, roles)
                        this.setState({
                          roles: newRoles
                        })
                        userActions.patch(u._id, { roles: newRoles })
                      }}
                    />
                  </label>
                )}
              </div>
            )}
          </div>
          {this._appDevices()}
          {this._renderApiKeys()}
        </div>
      </div>
    )
  }
}

export default bindAllActions(UserCard)

UserCard.displayName = 'UserCard'
